/**
 * HustlePlate logo — inline SVG wordmark.
 * - Plate iconmark (rim + fork + knife) + "HustlePlate" wordmark
 * - Color tokens come from CSS — pass `accent` to override
 */
export default function HustlePlateLogo({ size = 36, color = "#121614", accent = "#C05746" }) {
  return (
    <span
      data-testid="hustleplate-logo"
      style={{ display: "inline-flex", alignItems: "center", gap: 10 }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Outer plate rim */}
        <circle cx="32" cy="32" r="28" stroke={color} strokeWidth="3" />
        {/* Inner ring */}
        <circle cx="32" cy="32" r="20" stroke={accent} strokeWidth="2" strokeDasharray="2 3" opacity="0.85" />
        {/* Knife (right) */}
        <path d="M40 16 L40 36 L44 36 L44 44 L40 44 L40 48"
              stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        {/* Fork (left) — three tines + handle */}
        <path d="M22 16 L22 24 M26 16 L26 24 M30 16 L30 24"
              stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        <path d="M26 24 L26 48" stroke={color} strokeWidth="3" strokeLinecap="round" />
        <rect x="22" y="24" width="8" height="4" rx="1.5" fill={color} />
        {/* Speed-line accent through the plate (the "Hustle" cue) */}
        <path d="M8 32 L18 32" stroke={accent} strokeWidth="3" strokeLinecap="round" />
        <path d="M50 28 L60 28" stroke={accent} strokeWidth="2" strokeLinecap="round" opacity="0.6" />
        <path d="M52 36 L58 36" stroke={accent} strokeWidth="2" strokeLinecap="round" opacity="0.6" />
      </svg>
      <span
        style={{
          fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
          fontSize: Math.round(size * 0.62),
          fontWeight: 700,
          letterSpacing: "-0.015em",
          color,
          whiteSpace: "nowrap",
        }}
      >
        Hustle<span style={{ color: accent }}>Plate</span>
      </span>
    </span>
  );
}
